 
 //top popup 
    let debug = false; //true => 常時表示(テスト用) , false => 通常モード

	var cook;
    var cStart, cEnd;
    var cnt;

    var date1, date2;
    var kigen = 1;



    date1 = new Date();
    date1.setTime(date1.getTime() + kigen * 24 * 60 * 60 * 1000);
    date2 = date1.toGMTString();
    console.log(date2);

    function getParam(name, url) {    
        if (!url) url = window.location.href;    
        name = name.replace(/[\[\]]/g, "\\$&");    
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);    
        if (!results) return null;    
        if (!results[2]) return '';    
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    if (navigator.cookieEnabled) {

        cook = document.cookie + ";";
        cStart = cook.indexOf("counts=", 0);

        if (cStart == -1 || debug) {
            document.cookie = "counts=1;expires=" + date2;
            var visited = getParam('popmode');
            if (visited) {
                var trgtrg = document.getElementById("js-popup");
                trgtrg.style.display = "none";
            } else {
                window.addEventListener('DOMContentLoaded', function() {
                    var line_popup = document.getElementById('js-popup');
                    if (!line_popup) return;
                    line_popup.classList.add('is-show');

                    var blackBg = document.getElementById('js-black-bg');
                    var closeBtn = document.getElementById('js-close-btn');

                    closePopUp(blackBg);
                    closePopUp(closeBtn);

                    function closePopUp(elem) {
                        if (!elem) return;
                        elem.addEventListener('click', function() {
                            line_popup.classList.remove('is-show');
                        })
                    }
                })
            }
        } else {
          
            cEnd = cook.indexOf(";", cStart);
            cnt = cook.substring(cStart + 7, cEnd);
            try {
                cnt = parseInt(cnt) + 1;
                console.log(cnt + "回目の訪問です！");
                document.cookie = "counts=" + cnt + ";expires=" + 0;
            } catch (e) {
                document.write("訪問回数の取得に失敗しました。");
            }
        }
    } else {
        document.write("cookieが使用できません。");
    }